export default __webpack_public_path__ + "static/media/face-palm-kyle.2d984f44.gif";